/* The Standard Lab — galería, pestañas, carruseles, cuenta regresiva y opiniones. */
(function () {
  // Galería: miniaturas y flechas cambian la imagen principal.
  document.querySelectorAll('[data-sl-gal]').forEach(function (gal) {
    var principal = gal.querySelector('[data-sl-gal-img]');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-sl-thumb]'));
    var actual = 0;
    function ir(i) {
      if (!thumbs.length) return;
      actual = (i + thumbs.length) % thumbs.length;
      var t = thumbs[actual];
      principal.src = t.dataset.src;
      principal.alt = t.dataset.alt || '';
      thumbs.forEach(function (x, k) { x.setAttribute('aria-current', k === actual ? 'true' : 'false'); });
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { ir(k); }); });
    gal.querySelectorAll('[data-sl-gal-paso]').forEach(function (b) {
      b.addEventListener('click', function () { ir(actual + Number(b.dataset.slGalPaso)); });
    });
  });

  // Pestañas.
  document.querySelectorAll('[data-sl-tabs]').forEach(function (caja) {
    var botones = caja.querySelectorAll('[role="tab"]');
    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        botones.forEach(function (x) {
          var on = x === b;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          caja.querySelector('#' + x.getAttribute('aria-controls')).hidden = !on;
        });
      });
    });
  });

  // Carruseles con flechas: data-sl-mover="<id de la pista>" data-paso="1|-1".
  document.querySelectorAll('[data-sl-mover]').forEach(function (b) {
    b.addEventListener('click', function () {
      var pista = document.getElementById(b.dataset.slMover);
      if (!pista) return;
      var hijo = pista.firstElementChild;
      var ancho = hijo ? hijo.getBoundingClientRect().width + 20 : pista.clientWidth;
      pista.scrollBy({ left: ancho * Number(b.dataset.paso || 1), behavior: 'smooth' });
    });
  });

  // Cuenta regresiva hasta la medianoche de Argentina (UTC-3).
  var relojes = document.querySelectorAll('[data-sl-cuenta]');
  if (relojes.length) {
    var dos = function (n) { return (n < 10 ? '0' : '') + n; };
    var tic = function () {
      var ahora = Date.now();
      var ar = new Date(ahora - 3 * 3600 * 1000);
      var fin = Date.UTC(ar.getUTCFullYear(), ar.getUTCMonth(), ar.getUTCDate() + 1) + 3 * 3600 * 1000;
      var s = Math.max(0, Math.floor((fin - ahora) / 1000));
      relojes.forEach(function (r) {
        r.querySelector('[data-d]').textContent = '00';
        r.querySelector('[data-h]').textContent = dos(Math.floor(s / 3600));
        r.querySelector('[data-m]').textContent = dos(Math.floor(s % 3600 / 60));
        r.querySelector('[data-s]').textContent = dos(s % 60);
      });
    };
    tic();
    setInterval(tic, 1000);
  }

  // Opiniones: JSON en assets, de a 10.
  document.querySelectorAll('[data-sl-opiniones]').forEach(function (caja) {
    var lista = caja.querySelector('[data-lista]');
    var mas = caja.querySelector('[data-mas]');
    var base = caja.dataset.base;
    var escapar = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    var todas = [];
    var mostradas = 0;
    var pintar = function () {
      var html = '';
      todas.slice(mostradas, mostradas + 10).forEach(function (o) {
        var fotos = (o.img || []).map(function (f) {
          return '<img src="' + base.replace('__ARCHIVO__', f) + '" alt="Foto de ' + escapar(o.n) + '" loading="lazy" width="110" height="110">';
        }).join('');
        html += '<div class="sl-op__item"><div class="sl-op__cab"><span class="sl-op__ini">' + escapar(o.n.charAt(0)) + '</span><div>' +
          '<span class="sl-op__nombre">' + escapar(o.n) + '</span>' + (o.v ? '<span class="sl-op__ver">' + escapar(caja.dataset.verificada) + '</span>' : '') +
          '<div class="sl-op__fecha">' + escapar(o.f) + '</div></div></div>' +
          '<span class="sl-estrellas" aria-label="' + o.r + ' de 5">' + '★★★★★'.slice(0, o.r) + '<span style="color:#ddd">' + '★★★★★'.slice(o.r) + '</span></span>' +
          (o.t ? '<h4>' + escapar(o.t) + '</h4>' : '') + '<p>' + escapar(o.x) + '</p>' +
          (fotos ? '<div class="sl-op__fotos">' + fotos + '</div>' : '') + '</div>';
      });
      lista.insertAdjacentHTML('beforeend', html);
      mostradas += 10;
      mas.hidden = mostradas >= todas.length;
    };
    fetch(caja.dataset.json).then(function (r) { return r.json(); }).then(function (d) {
      todas = d;
      pintar();
    }).catch(function () { mas.hidden = true; });
    mas.addEventListener('click', pintar);
  });

  // Barra fija: aparece cuando el botón de la ficha queda arriba de la pantalla y aprieta el botón real (respeta Kaching).
  (function () {
    var barra = document.querySelector('[data-sl-barra]');
    var principal = document.querySelector('.sl-prod__form button[name="add"]');
    if (!barra || !principal) return;
    barra.hidden = false;
    var revisar = function () { barra.classList.toggle('is-visible', principal.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', revisar, { passive: true });
    revisar();
    barra.querySelector('[data-sl-barra-btn]').addEventListener('click', function () { principal.click(); });
  })();

  // Carrusel automático (reseñas cortas de la ficha): pasa solo, se frena mientras la persona lo toca o pasa el mouse.
  document.querySelectorAll('[data-sl-auto]').forEach(function (caja) {
    var pista = caja.querySelector('[data-sl-auto-pista]');
    var puntos = caja.querySelector('[data-sl-auto-puntos]');
    var items = pista ? pista.children : [];
    if (items.length < 2) return;
    var actual = 0;
    var pausa = false;
    for (var i = 0; i < items.length; i++) {
      var p = document.createElement('button');
      p.type = 'button';
      p.setAttribute('aria-label', 'Reseña ' + (i + 1));
      p.addEventListener('click', (function (k) { return function () { ir(k); }; })(i));
      puntos.appendChild(p);
    }
    function marcar() {
      for (var k = 0; k < puntos.children.length; k++) puntos.children[k].classList.toggle('is-on', k === actual);
    }
    function ir(k) {
      actual = (k + items.length) % items.length;
      pista.scrollTo({ left: items[actual].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
      marcar();
    }
    pista.addEventListener('scroll', function () {
      var k = Math.round(pista.scrollLeft / pista.clientWidth);
      if (k !== actual) { actual = k; marcar(); }
    }, { passive: true });
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { caja.addEventListener(ev, function () { pausa = true; }, { passive: true }); });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { caja.addEventListener(ev, function () { pausa = false; }, { passive: true }); });
    marcar();
    setInterval(function () { if (!pausa && !document.hidden) ir(actual + 1); }, Number(caja.dataset.slAuto) || 4500);
  });
})();

// Videos de «Ellos ya se animaron»: cargan y se reproducen solo cuando están a la vista.
(function () {
  var vids = document.querySelectorAll('[data-sl-video]');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src) v.src = v.dataset.src;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else { v.pause(); }
    });
  }, { threshold: 0.4 });
  vids.forEach(function (v) { obs.observe(v); });
})();
